// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { useContext } from "react";
import { store } from "../../Helper/Context/Store";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Autoplay, Pagination } from "swiper/modules";
import "./BestSellerSection.css";
import ProductCard from "../ProductCard/ProductCard";
import ProductCard1 from "../ProductCard/ProductCard1";
import { Skeleton } from "antd";
import TopIcon from "../../assets/img/leaf-1.png";
import BottomIcon from "../../assets/img/leaf-2.png";
export default function BestSellerSection({ itemsData, heading1, heading2 }) {
  const { cartItems } = useContext(store);
  return (
    <section className="my-5 section-spacing-x beat-seller-section">
      <img src={TopIcon} className="img-fluid top-left-icon" />
      <img src={BottomIcon} className="img-fluid bottom-right-icon" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 mx-auto text-center text-white main-heading-box">
            <h2 className="main-heading text-white">{heading1}</h2>
            <p>{heading2}</p>
          </div>
          <div className="col-12">
            <Swiper
              pagination={{
                clickable: true,
                dynamicBullets: true,
              }}
              slidesPerView={2}
              spaceBetween={20}
              autoplay="false"
              // autoplay={{
              //   delay: 2500,
              //   disableOnInteraction: false,
              // }}
              breakpoints={{
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 20,
                },
              }}
              modules={[Autoplay, Pagination]}
              className="mySwiper pb-4 pb-lg-5 swiper-slide-height">
              {itemsData.length > 0 ? (
                itemsData?.map((data, index) => {
                  const isInCart = cartItems.find((item) => {
                    if (item.fld_variantid === data.fld_variantid) {
                      return item;
                    }
                  });
                  return (
                    <SwiperSlide
                      key={`exclusive-${index}`}
                      className="exclusive-offers-card mb-4 mb-lg-0">
                      <ProductCard1 productData={data} isInCart={isInCart} />
                    </SwiperSlide>
                  );
                })
              ) : (
                <div className="col-12">
                  <div className="row">
                    <div className={`col-md-6 col-lg-3 col-6 mb-4 mb-lg-0`}>
                      <div className="product-img-skeleton">
                        <Skeleton.Image className="h-100 w-100" />
                        <div className="buttons flex-column detailsbtn mb-0">
                          <h2 className="prod-price">
                            <Skeleton.Button />
                          </h2>
                        </div>
                        <div className="mt-3">
                          <Skeleton.Input />
                        </div>
                      </div>
                    </div>
                    <div className={`col-md-6 col-lg-3 col-6 mb-4 mb-lg-0`}>
                      <div className="product-img-skeleton">
                        <Skeleton.Image className="h-100 w-100" />
                        <div className="buttons flex-column detailsbtn mb-0">
                          <h2 className="prod-price">
                            <Skeleton.Button />
                          </h2>
                        </div>
                        <div className="mt-3">
                          <Skeleton.Input />
                        </div>
                      </div>
                    </div>
                    <div className={`col-md-6 col-lg-3 col-6 mb-4 mb-lg-0`}>
                      <div className="product-img-skeleton">
                        <Skeleton.Image className="h-100 w-100" />
                        <div className="buttons flex-column detailsbtn mb-0">
                          <h2 className="prod-price">
                            <Skeleton.Button />
                          </h2>
                        </div>
                        <div className="mt-3">
                          <Skeleton.Input />
                        </div>
                      </div>
                    </div>
                    <div className={`col-md-6 col-lg-3 col-6 mb-4 mb-lg-0`}>
                      <div className="product-img-skeleton">
                        <Skeleton.Image className="h-100 w-100" />
                        <div className="buttons flex-column detailsbtn mb-0">
                          <h2 className="prod-price">
                            <Skeleton.Button />
                          </h2>
                        </div>
                        <div className="mt-3">
                          <Skeleton.Input />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}
